module.exports = __webpack_public_path__ + "bootleggers_backdrop.jpg?b22a015476af79e37286b6e2ea2893ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_backdrop.jpg
// module id = 31
// module chunks = 0